import {assert} from 'assert-ts';
import type {LinkAction} from 'types';
import type {LinkedValueSearchFieldConfig} from 'feature/linkedValueSearch/types';
import {FieldExtensionEnum} from 'sceneExtensions/types';
import type {
  LinkedValueLink,
  VerifiedLinkedValueLink,
} from 'schemaDefinition/types';
import {useSceneExtensionContext} from 'sceneExtensions/contexts';

export const useLinkedValueSearchFieldContext = () => {
  const extension = useSceneExtensionContext<
    FieldExtensionEnum.linkedValueSearch,
    LinkedValueLink,
    VerifiedLinkedValueLink,
    LinkAction,
    LinkedValueSearchFieldConfig
  >(FieldExtensionEnum.linkedValueSearch);
  return assert(extension).fieldContext;
};
